"use strict";

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = exports.Address = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _AddressV2AutoSuggest = _interopRequireDefault(require("../PrimitiveAddress/AddressV2AutoSuggest"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nswPointV2Api = _interopRequireDefault(require("../PrimitiveAddress/nswPointV2Api"));

var _componentAnalytics = require("../../Components/ComponentAnalytics/componentAnalytics");

var _excluded = ["showManual"];

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var defaultManualFields = {
  suburb: "",
  state: "",
  postcode: "",
  addressLine: ""
};
var defaultAddressFields = Object.assign({}, defaultManualFields, {
  nswPointId: "",
  formattedAddress: "",
  unitNumber: "",
  buildingNumber: "",
  streetNumber: "",
  streetName: "",
  streetType: "",
  propertyName: "",
  latitude: "",
  longitude: ""
});

var errorMessage = function errorMessage(address) {
  var manualAddressMessages = Object.keys(defaultManualFields) // eslint-disable-next-line security/detect-object-injection
  .filter(function (key) {
    return !address[key];
  }).reduce(function (acc, cur) {
    var _Object$assign;

    return Object.assign({}, acc, (_Object$assign = {}, _Object$assign[cur] = "This field is required.", _Object$assign));
  }, {});
  var autoSuggestMessage = address.formattedAddress ? {} : {
    autoSuggest: "This field is required."
  };
  return Object.assign({}, manualAddressMessages, autoSuggestMessage);
};

var isComplete = function isComplete(address) {
  if (address.validated) {
    return !0;
  } // eslint-disable-next-line security/detect-object-injection


  return Object.keys(defaultManualFields).every(function (key) {
    return address[key];
  });
};

var isAddressEqual = function isAddressEqual(address, otherAddress) {
  var keys = Object.keys(defaultAddressFields); // eslint-disable-next-line security/detect-object-injection

  return keys.every(function (key) {
    return address[key] === otherAddress[key];
  });
};

var Address = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Address, _Component);

  function Address() {
    var _this = _Component.call(this) || this;

    _this.state = {
      hasError: !1,
      errorMessage: {}
    };

    _this.setAddressFields = function (_ref) {
      var showManual = _ref.showManual,
          addressFields = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);

      _this.handleChange(addressFields);
    };

    _this.setManualAddress = function () {
      _this.handleChange(Object.assign({}, defaultAddressFields, {
        validated: !1
      }));

      _this.props.onSwitchToManual && _this.props.onSwitchToManual();
    };

    _this.handleChange = function (address) {
      var hasError = _this.hasError(address);

      var errorMessage = _this.errorMessage(address);

      _this.setState({
        hasError: hasError,
        errorMessage: errorMessage
      });

      _this.props.onChange({
        hasError: hasError,
        isComplete: isComplete(address),
        address: Object.assign({}, address, {
          country: "Australia"
        })
      });
    };

    _this.errorMessage = function (address) {
      return "function" == typeof _this.props.errorMessage ? _this.props.errorMessage(address) : _this.props.errorMessage;
    };

    _this.hasError = function (address) {
      return "function" == typeof _this.props.hasError ? _this.props.hasError(address) : _this.props.hasError;
    };

    (0, _componentAnalytics.trackMe)("Address");
    return _this;
  }

  var _proto = Address.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.handleChange(this.props.address);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!isAddressEqual(prevProps.address, this.props.address)) {
      this.handleChange(this.props.address);
    }

    if (prevProps.hasError !== this.props.hasError && "boolean" == typeof this.props.hasError) {
      this.setState({
        hasError: this.props.hasError
      });
    }

    if (prevProps.errorMessage !== this.props.errorMessage && "object" == typeof this.props.errorMessage) {
      this.setState({
        errorMessage: this.props.errorMessage
      });
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.default, {
      id: this.props.id,
      name: this.props.name,
      disabled: this.props.disabled,
      placeholder: this.props.placeholder,
      addressType: this.props.addressType,
      apiKey: this.props.apiKey,
      label: this.props.addressLabel,
      onSwitchToManual: this.setManualAddress,
      onSwitchToAutoSuggest: this.props.onSwitchToAutoSuggest,
      onAddressHasBecomeInvalid: this.setAddressFields,
      onAddressHasBecomeValid: this.setAddressFields,
      "data-test": "address",
      value: Object.assign({}, this.props.address),
      emptyAddressValid: !this.props.required,
      helpMessage: this.props.helpMessage,
      manualModeMessage: this.props.manualModeMessage,
      manualAddressHeading: this.props.manualAddressHeading,
      hasError: this.props.showErrors && this.state.hasError,
      errorMessage: this.state.errorMessage,
      backendAPI: this.props.backendAPI,
      onBlur: this.props.onBlur,
      apiState: this.props.apiState
    });
  };

  return Address;
}(_react.Component);

exports.Address = Address;
Address.defaultProps = {
  address: {},
  addressLabel: "Business address",
  addressType: "business",
  apiKey: "",
  required: !1,
  showErrors: !1,
  errorMessage: errorMessage,
  hasError: function hasError(address) {
    return !isComplete(address);
  },
  backendAPI: _nswPointV2Api.default,
  onBlur: function onBlur() {}
};
Address.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  address: _propTypes.default.object.isRequired,
  addressLabel: _propTypes.default.string.isRequired,
  apiState: _propTypes.default.string,
  addressType: _propTypes.default.string.isRequired,
  apiKey: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  required: _propTypes.default.bool.isRequired,
  helpMessage: _propTypes.default.string,
  manualModeMessage: _propTypes.default.string,
  manualAddressHeading: _propTypes.default.string,
  showErrors: _propTypes.default.bool.isRequired,
  backendAPI: _propTypes.default.shape({
    getLatestSuggestions: _propTypes.default.func.isRequired,
    getDetailsById: _propTypes.default.func.isRequired
  }).isRequired,
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  hasError: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  onSwitchToManual: _propTypes.default.func,
  onSwitchToAutoSuggest: _propTypes.default.func
};
var _default = Address;
exports.default = _default;